var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.4498 2.65589L10.8185 2.65655C9.53948 2.65655 9.29184 3.21772 9.29184 4.04128V5.85715H12.3423L12.3412 8.70143H9.29184V16H6.11006V8.70143H3.45003V5.85715H6.11006V3.75978C6.11006 1.32553 7.72067 0 10.0727 0L12.45 0.00349174L12.4498 2.65589Z","fill":"currentColor"}));
}

Facebook.defaultProps = {"width":"17","height":"16","viewBox":"0 0 17 16","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
